window.location = '/unsupported-browser?failed=js-modules';
